import { components, permissionPresets, services } from '@/utils'

import tasksItem from '@/components/services/billings/tasks/item'

export default function(h) {
  if (this.checkPermissions(`advanced.${services.tasks}.find`, permissionPresets.meUp)) {
    return h(
      components.card,
      {
        props: {
          rounded: true,
          outline: true
        }
      },
      [
        h(
          'tasks-template',
          {
            scopedSlots: {
              item: ({ item }) => {
                return h(tasksItem, { props: { value: item } })
              }
            }
          }
        )
      ]
    )
  }
}
